import LocalStorage from "./LocalStorage";

export const USER_ROLES = {
    "CUSTOMER":"customer",
    "DAR_ADMIN":"dar_admin", //ocp普通管理员
    "ADMIN":"admin", //超级管理员
    "DAR_SUPER_ADMIN":"dar_super_admin", //ocp超级管理员
    "DAR_ACCOUNTING":"dar_accounting" //财务
}

export const PERMISSION_DICT = {


    //common
    AccessCheckCreditCard: 'credit:card:binding',//这个对应接口是否有绑定信用卡,admin没有权限看是否绑定信用卡，customer有权限看
    QueryOwnerInfo:'query:owner:info',//对应接口，能否调用search owner id or name，admin具备权限查看所有ownerInfo和搜索，customer没有
    TemplateFileDownload:'template:file:download',//对应所有的download接口，是否有权限
    choiceSkuList:'choice:sku:list',//获取产品sku// 接口


    //dashboard page
    DashBoardDataList:'dashboard:data:list',

    //stock check page
    InventoryStockSku:'inventory:stock:sku',//stock check里面的produc sku 接口
    InventoryStockProduct:'inventory:stock:product', //stock check里面product list接口
    InventoryStockBatch:'inventory:stock:batch',//stock check里面batch list接口
    InventoryStockBatchExport:'inventory:stock:batchExport', //stock check里面batch export
    InventoryStockProductExport:'inventory:stock:productExport',//stock check里面product export

    //product page
    InventoryProductList:'inventory:product:list',//product的list
    InventoryProductCheckUnique:'inventory:product:checkUnique', //check product sku是否被占用接口
    InventoryProductSync:'inventory:product:sync',//product批量同步接口权限
    InventoryProductSyncTrigger:'inventory:product:syncStock',//product触发同步接口权限
    InventoryProductInfo:'inventory:product:info',//product看产品info权限
    InventoryProductExport:'inventory:product:export',//product的export权限
    InventoryProductAdd:'inventory:product:add',//product的添加权限
    InventoryProductModify:'inventory:product:modify',//product的修改权限
    InventoryProductUpload:'inventory:product:upload',//product的上传权限
    InventoryProductModifyStatus:'inventory:product:modifyStatus',
    InventoryProductSafety:'inventory:product:safety',//安全库存

    //kit page
    InventoryKitModify:'inventory:kit:modify',//kit modify接口
    InventoryKitModifyStatus:'inventory:kit:modifyStatus', //kit的active状态改变权限
    InventoryKitList:'inventory:kit:list',//kit list
    InventoryKitInfo:'inventory:kit:info',//获取kit的info接口
    InventoryKitUpload:'inventory:kit:upload',//kit upload接口
    InventoryKitAdd:'inventory:kit:add',//kit添加接口

    InventoryKittingAdd:'inventory:kitting:add',//kit添加接口
    InventoryKittingList:'inventory:kitting:list',//kit list
    InventoryKittingInfo:'inventory:kitting:info',//获取kit的info接口
    InventoryKittingSubmit:'inventory:kitting:submit',//获取kit的submit接口
    InventoryKittingCancel:'inventory:kitting:cancel',//获取kit的cancel接口
    InventoryKittingEdit:'inventory:kitting:edit',//获取kit的edit接口
    InventoryKittingExport:'inventory:kitting:export',//获取kit的Export接口

    //packaging
    InventoryPackagingInfo:'inventory:packaging:info', //package info接口
    InventoryPackagingList:'inventory:packaging:list', //package list接口
    InventoryPackagingExport:'inventory:packaging:export',//package export接口
    InventoryPackagingExportInvalid:'inventory:packaging:exportInvalid',//package export invalid接口

    //sku mapping
    InventorySkuMappingInfo:'inventory:skuMapping:info', //sku mapping info 接口
    InventorySkuMappingUpload:'inventory:skuMapping:upload', //sku upload接口
    InventorySkuMappingModify:'inventory:skuMapping:modify',// modify sku mapping接口
    InventorySkuMappingAdd:'inventory:skuMapping:add', //添加sku mapping 接口
    InventorySkuMappingList:'inventory:skuMapping:list', //获取sku mapping list接口

    //owner customer
    OwnerCustomerInfo:'owner:customer:info', //获取customer info接口
    OwnerCustomerAdd:'owner:customer:add', //添加customer接口
    OwnerCustomerList:'owner:customer:list', //获取customer list接口
    OwnerCustomerModify:'owner:customer:modify', //edit customer 接口
    OwnerCustomerChangeStatus:'owner:customer:changeStatus', // change active operation接口
    OwnerCustomerAddAddress:'owner:customer:add-address', // Add customer Address接口
    OwnerCustomerModifyAddress:'owner:customer:modify-address', // Modify customer Address接口
    OwnerCustomerDeleteAddress:'owner:customer:remove-address', // Delete customer Address接口
    OwnerCustomerBatchImport:'owner:customer:batchImport',// d导入customer Address接口

    //cargo owner
    CustomerCargoList:'customer:cargo:list', //cargo owner list接口
    CustomerCargoInfo:'customer:cargo:info', //cargo owner info接口
    CustomerCargoAudit:'customer:cargo:auditNewOwner', //cargo owner info接口
    CustomerCargoDiscountModify:'customer:cargo:discountModify', //modify discount接口
    CustomerCargoDiscountAdd:'customer:cargo:discountAdd', //添加 discount接口
    CustomerCargoCarrierModify:'customer:cargo:carrierModify',// modify carrier接口
    CustomerCargoStorageFeeTermModify:'customer:cargo:storageFeeTermModify',// modify storage fee term接口
    CustomerCargoModifyMainInfo:'customer:cargo:modifyMainInfo',

    //inbound
    InboundDataList:'inbound:data:list', //get inbound list
    InboundDataDelete:'inbound:data:delete',
    InboundDataAdd:'inbound:data:add',
    InboundDataAddReturn:'inbound:data:addReturn',
    InboundDataExport:'inbound:data:export',
    InboundDataModify:'inbound:data:modify',
    InboundDataInfo:'inbound:data:info',
    InboundDataUpload:'inbound:data:upload',
    CustomerChoiceAddress:'customer:choice:address',// choice customer address
    InboundDataChange:'inbound:data:change', // change asn status
    InboundDataSubmit:'inbound:data:submit', //todo:
    InboundDataAudit:'inbound:data:audit',//todo
    InboundWarehouseList:'inbound:warehouse:list',
    InboundCheckUnique:"inbound:fromOrderNo:unique",

    //transfer
    TransferOrderList:'transfer:order:list',
    TransferOrderDetail:'transfer:order:details',
    TransferOrderSave:'transfer:order:save',
    TransferOrderModify:'transfer:order:modify',
    TransferOrderUpload:'transfer:order:upload',
    TransferOrderSubmit:'transfer:order:submit',
    TransferOrderCancel:'transfer:order:cancel',


    //outbound
    OutboundWholesaleAdd:'outbound:wholesale:add',//
    OutboundWholesaleSaveAndSubmit:'outbound:wholesale:save-and-submit',
    OutboundWholesaleModifyAndSubmit:'outbound:wholesale:modify-and-submit',
    OutboundWholesaleSplit:'outbound:wholesale:split',
    OutboundWholesaleStockCheck:'order-line:inventory:check',
    OutboundWholesaleModify:'outbound:wholesale:modify',//
    OutboundWholesaleChange:'outbound:wholesale:change', //
    OutboundWholesaleExport:'outbound:wholesale:export',//
    OutboundWholesaleInfo:'outbound:wholesale:info',//
    OutboundWholesaleList:'outbound:wholesale:list',//
    OutboundDataDelete:'outbound:data:delete',// wholesale和ecommerce delete同一个接口,后面拆分成 OutboundWholesaleDelete & OutboundEcommerceDelete
    OutboundWholesaleUpload: 'outbound:wholesale:upload',//
    OutboundWholesaleDelete:'outbound:wholesale:delete',//todo
    OutboundWholesaleWithdraw:'outbound:wholesale:withdraw',
    OutboundWholesaleRelease:'outbound:wholesale:release',
    OutboundWholesaleModifyShipStatus:'outbound:wholesale:modifyShipStatus',
    OutboundWholesaleCheckUnique:"warehouse:fromOrderNo:unique",
    //ecommerce
    OutboundEcommerceList:'outbound:ecommerce:list',//
    OutboundEcommerceInfo:'outbound:ecommerce:info',//
    OutboundEcommerceModify:'outbound:ecommerce:modify',//
    OutboundEcommerceCopy:'outbound:ecommerce:copy',//
    OutboundEcommerceExport:'outbound:ecommerce:export',
    OutboundEcommerceDelete:'outbound:ecommerce:delete',//todo
    OutboundEcommerceWithdraw:'outbound:ecommerce:withdraw',
    OutboundEcommerceChange:'outbound:ecommerce:change',
    OutboundEcommerceRelease:'outbound:ecommerce:release',
    OutboundEcommerceModifyAndSubmit:'outbound:ecommerce:modify-and-submit',
    //online shop
    IntegrationOnlineInfo:'integration:online:info',//
    IntegrationOnlineBasicInfo:'integration:online:basicInfo',//done
    IntegrationOnlineApiParam:'integration:online:apiParam',
    IntegrationOnlineSaveUpdate:'integration:online:saveUpdate',//接口改造，拆封成 add & modify
    IntegrationOnlineAdd:'integration:online:add', //save
    IntegrationOnlineModify:'integration:online:modify', //modify

    IntegrationOnlineOwnerInfo:'integration:online:ownerInfo',
    IntegrationOnlineEcShopId:'integration:online:ecShopId',
    IntegrationOnlineList:'integration:online:list',//


    //non-canada report
    ReportNonCanadaExport:'report:nonCanada:export',
    ReportNonCanadaList:'report:nonCanada:list',

    //inventory report
    ReportInventorySku:'report:inventory:sku',
    ReportInventorySkuExport:'report:inventory:skuExport',

    //batch report
    ReportInventoryBatchExport:'report:inventory:batchExport',
    ReportInventoryBatch:'report:inventory:batch',

    //expire day report
    ReportInventoryExpire:'report:inventory:expire',
    ReportInventoryExpireExport:'report:inventory:expireExport',

    // date report
    ReportInventoryDate:'report:inventory:date',
    ReportInventoryDateExport:'report:inventory:dateExport',
    //location report
    ReportInventoryLocation:'report:inventory:location',
    ReportInventoryLocationExport:'report:inventory:locationExport',

    //asn report
    ReportInventoryAsn:'report:inventory:asn',
    ReportInventoryAsnExport:'report:inventory:asnExport',

    //aging report
    ReportInventoryAging:'report:inventory:aging',
    ReportInventoryAgingExport:'report:inventory:agingExport',

    //transaction report
    ReportTransaction:'transaction:report:list',
    ReportTransactionExport:'transaction:report:export',

    //cost detail report
    ReportFulfillmentCostDetail:'report:fulfillment:costDetail',
    ReportFulfillmentCostDetailInfo:'report:fulfillment:info',
    ReportFulfillmentCostDetailExport:'report:fulfillment:costDetailExport',

    //cost summary report
    ReportFulfillmentCost:'report:fulfillment:cost',
    ReportFulfillmentCostExport:'report:fulfillment:costExport',

    //sales summary report
    ReportSalesSummery:'report:sales:summery',
    ReportSalesSummeryExport:'report:sales:summeryExport',

    //sales individual report
    ReportSalesIndividual:'report:sales:individual',
    ReportSalesIndividualExport:'report:sales:individualExport',

    //sales warehouse report
    ReportSalesWarehouse:'report:sales:warehouse',
    ReportSalesWarehouseExport:'report:sales:warehouseExport',

    //sales sku report
    ReportSalesSku:'report:sales:sku',
    ReportSalesSkuExport:'report:sales:skuExport',

    //sales customer report
    ReportSalesCustomer:'report:sales:customer',
    ReportSalesCustomerExport:'report:sales:customerExport',

    //sales cost report
    ReportSalesCost:'report:sales:cost',
    ReportSalesCostExport:'report:sales:costExport',

    //sales batch report
    ReportSalesBatch:'report:sales:batch',
    ReportSalesBatchExport:'report:sales:batchExport',

    //billing other fee
    BillingOtherList:'billing:other:list',
    BillingOtherInfo:'billing:other:info',
    BillingOtherExport:'billing:other:export',
    BillingOtherCancel:'billing:other:cancel',

    //billing collection requisition
    BillingCollectionList:'billing:collection:list',//
    BillingCollectionAdd:'billing:collection:add',//
    BillingCollectionCheck:'billing:collection:check',//
    BillingCollectionModify:'billing:collection:modify',//
    BillingCollectionInfo:'billing:collection:info',//
    BillingCollectionDelete:'billing:collection:delete',//
    BillingCollectionWarehouse:'billing:collection:warehouse',
    BillingCollectionExport:'billing:collection:export',
    BillingCollectionGenerate:'billing:collection:generate',

    //billing invoice

    BillingInvoicePrint:'billing:invoice:print',
    BillingInvoiceInfo:'billing:invoice:info',
    BillingInvoiceList:'billing:invoice:list',
    BillingInvoiceExport:"billing:invoice:export",
    BillingInvoiceDetail:'billing:invoice:detail',

    //invoice:quickbooks
    BillingInvoiceConnect:"invoice:quickbooks:connect",
    BillingInvoiceOCPGenerate:"invoice:ocp:generate",
    BillingInvoiceQBGenerate:"invoice:quickbooks:generate",
    BillingInvoiceBalancePay:"invoice:ownerCash:deduction",
    BillingInvoiceCreditCardPay:"invoice:creditCard:deduction",
    BillingInvoiceEmailSend:"invoice:email:send",
    BillingInvoiceDetailExport:"invoice:detail:export",
    BillingInvoiceCancel:"billing:invoice:cancel",


    BillingInvoiceSendToQB:"billing:invoice:sendToQB",
    BillingInvoiceCollect:"billing:invoice:collect",
    BillingInvoiceGeneratePDF:"billing:invoice:generatePdf",
    BillingInvoiceEmailBatchSend:"billing:invoice:sendEmail",

    BillingInvoiceEdit:"billing:invoice:save",

    //billing storage fee
    BillingStorageList:'billing:storage:list',
    // BillingStorageQuery:'job:storage:query',
    BillingStorageExport:'billing:storage:export',
    BillingStorageUpdate:'billing:storage:update',


    //billing calculator
    BillingCalculateEstimate:'billing:calculate:estimate',
    BillingCalculateCalculate:'billing:calculate:calculate',

    //account user info
    AccountProfileModify:'account:profile:modify',
    AccountEmailModify:'account:email:modify',
    AccountPictureUpload:'account:picture:upload',
    AccountDataList:'account:data:list',

    //account change password
    AccountPasswordModify:'account:password:modify',


    //account stripe
    AccountPaymentId:'account:payment:id',
    AccountCustomerInfo:'account:customer:info', //获取client secret
    AccountCardList:'account:card:list', // card information


    //account address
    AccountMultiAddressList:'account:multiAddress:list',
    AccountMultiAddressDelete:'account:multiAddress:delete',
    AccountMultiAddressModify:'account:multiAddress:modify',
    AccountMultiAddressAdd:'account:multiAddress:add',

    //system setting
    SystemCommodityList:'system:commodity:list', // get commodity list
    SystemCommoditySave:'system:commodity:save', // add commodity info
    SystemCommodityUpdate:'system:commodity:update', // edit commodity info
    SystemCommodityDelete:'system:commodity:delete', // delete commodity info
    SystemCommodityInfo:'system:commodity:info', // get commodity preview
    SystemCommodityExport:'system:commodity:export', //download commodity list Excel file

    SystemCostList:'system:cost:list', // get size cost list
    SystemCostSave:'system:cost:save', // add size cost info
    SystemCostUpdate:'system:cost:update', // edit size cost info
    SystemCostDelete:'system:cost:delete', // delete size cost info
    SystemCostInfo:'system:cost:info', // get size cost preview
    SystemCostExport:'system:cost:export', // download size cost list Excel file

    //system user management
    SystemUserList:'system:user:list',
    SystemUserAdd:'system:user:add',

    SystemUserEmailFlagList:'system:user:listByLoginOwner',
    SystemUserModifyEmailFlag:'system:user:modifyEmailFlag',

    SystemUserResetPwd:'system:user:resetPwd',
    SystemUserQuery:'system:user:query', //user info
    SystemUserEdit:'system:user:edit',
    SystemUserRemove:'system:user:remove',

    //system storage fee Filter

    SystemAuthorityList:'system:authority:list', // get storage fee authority list
    SystemAuthoritySave:'system:authority:save', // add storage fee authority info
    SystemAuthorityUpdate:'system:authority:update', // edit storage fee authority info
    SystemAuthorityDelete:'system:authority:delete', // delete storage fee authority info
    SystemAuthorityInfo:'system:authority:info', // get storage fee authority preview

    //split order
    WarehouseMappingList:'warehouse:mapping:list', // get storage fee authority list
    WarehouseMappingSave:'warehouse:mapping:save', // add storage fee authority info
    WarehouseMappingUpdate:'warehouse:mapping:modify', // edit storage fee authority info
    WarehouseMappingInfo:'warehouse:mapping:info', // get storage fee authority preview


    //owner cash
    BillingCashList:'billing:cash:list', // get owner cash list
    BillingCashInfo:'billing:cash:info',// get owner cash detail
    BillingCashAdd:'billing:cash:add', // add owner cash
    BillingCashSubmit:'billing:cash:submit',// submit owner cash
    BillingCashAudit:'billing:cash:audit',// audit owner cash
    BillingCashModify:'billing:cash:modify',// modify owner cash
    BillingCashDelete:'billing:cash:delete',// delete owner cash
    BillingCashCancel:'billing:cash:cancel',// cancel owner cash
    BillingCashExport:'billing:cash:export',// cancel owner cash

    //warehouse setting
    SystemWarehouseList:'system:warehouse:list',
    SystemWarehouseInfo:'system:warehouse:info',
    SystemWarehouseSave:'system:warehouse:save',
    SystemWarehouseModify:'system:warehouse:modify',

    //openApi
    OpenapiGenerateAppInfo:'openapi:generate:appInfo', // add key and secret
    OpenapiGetAppInfo:'openapi:get:appInfo', //get api key and secret
    OpenapiGenerateAppToken:'openapi:generate:appToken', //generate token
    OpenapiGetAppToken:'openapi:get:appToken',

    //Webhook
    SystemWebhookList:'system:webhook:list', // add key and secret
    SystemWebhookAdd:'system:webhook:Add', //get api key and secret
    SystemWebhookModify:'system:webhook:update', //generate token
    SystemWebhookDelete:'system:webhook:delete',

    //Ticket
    SupportTicketList:'support:ticket:list',
    SupportTicketDetail:'support:ticket:detail',
    SupportTicketCreate:'support:ticket:create',
    SupportTicketComment:'support:ticket:comment',
    SupportTicketUpdate:'support:ticket:update',
    SupportTicketAssignee:'support:ticket:assignee',
    SupportTicketCommentRead:'support:ticket:comment:read',
    SupportTicketCommentDelete:'support:ticket:comment:delete',
    SupportTicketCommentEdit:'support:ticket:comment:edit',
    SupportTicketExport:'support:ticket:export',

    LastmileDiscountList:'lastmile:discount:list',
    LastmileDiscountAdd:'lastmile:discount:add',
    LastmileDiscountUpdate:'lastmile:discount:update',
    LastmileDiscountDelete:'lastmile:discount:delete',

    //claim
    SupportClaimList:"support:claim:list",
    SupportClaimCreate:"support:claim:create",
    SupportClaimDetail:'support:claim:detail',
    SupportClaimCommentAdd:"support:claim:comment:add",
    SupportClaimCommentDelete:"support:claim:comment:delete",
    SupportClaimCommentEdit:"support:claim:comment:edit",
    SupportClaimAgentUpdateStatus:"support:claim:agent:updateStatus",
    SupportClaimAccountingUpdateStatus:"support:claim:accounting:updateStatus",
    SupportClaimCustomerUpdateStatus:"support:claim:customer:updateStatus",
    OutboundWholesaleInfoByFromOrderNo:"outbound:wholesale:info-by-from-order-no",
    OutboundEcommerceInfoByFromOrderNo:"outbound:ecommerce:info-by-from-order-no",

    //notifications
    MessageNotificationList:"message:notification:list",
    MessageNotificationRead:"message:notification:read"



}


export const checkPermission = (permissionsToCheck) => {
    try {

        //check是否为超级管理员，如果是的话，直接拥有所有权限，返回 true


        if(JSON.parse(localStorage.getItem('permissions'))?.includes('*:*:*'))
        {
            return true;
        }



        //permissionsToCheck可以是string也可以是数组，
        const permissionsString = localStorage.getItem('permissions');
        if (permissionsString) {
            const permissionsArray = JSON.parse(permissionsString);
             if (Array.isArray(permissionsToCheck)) {
                 //如果permissionsToCheck是个数组，那么需要localStorage.getItem('permissions')里面包含每个permissionsToCheck中传入的string，满足返回true，否则为false
                 return permissionsToCheck.every(permission => permissionsArray.includes(permission));
            } else {
                 //如果permissionsToCheck是个数组
                return permissionsArray.includes(permissionsToCheck);
            }
        }
        return false;
    } catch (error) {
        console.error('Error parsing permissions from localStorage:', error);
        return false;
    }
};

export const ROLES_MAPPER = {
    "ADMIN":"00",
    "CUSTOMER":"10",
    "SUB_CUSTOMER":"20",
}
